import ApiUrl from "../../configTools/apiUrl";
const User = JSON.parse(localStorage.getItem("user-info"));

const videoUpload = (e,setUploadedFile,setShowLoading) =>{
    if(e.target.files && e.target.files[0]){
        setShowLoading(true);
        setUploadedFile('');
        let imageFile = e.target.files[0];
        const formData = new FormData();
        formData.append("file",imageFile);
        fetch(ApiUrl.API_URL_VideoFile, {
            method: 'POST',
            body: formData
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.success){
                setUploadedFile(data.url);
            }
            else{
                setShowLoading(false);
                console.log(data.responce);
            }
        });
    }
}

const reelUpload = (body,setValue)=>{
    if(User){
        fetch(ApiUrl.API_URL_Reels, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            },
            body: JSON.stringify(body)
          })
          .then(res=>res.json())
          .then(data =>{
            setValue(data);
        });
    }
    else{
        setValue([]);
    }
}

const reelGet = (setValues)=>{
    if(User){
        fetch(ApiUrl.API_URL_Reels, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            }
          })
          .then(res=>res.json())
          .then(data =>{
            setValues(data)
        });
    }
    else{
        setValues([]);
    }
}
const reelGetUsername = (username,page,setValues)=>{
    fetch(ApiUrl.API_URL_Reels+"/"+username+"/"+page, {
        method: 'GET'
      })
      .then(res=>res.json())
      .then(data =>{
        setValues(data)
    });
}

export default {videoUpload,reelUpload,reelGet,reelGetUsername}